import React from 'react';
import { classes } from 'as-ui-kit/utils/styles';
import styles from '../../styles.modules.scss';

const TableRowEmpty = () => {
    return (
	    <div className={classes(styles['row'], styles['row-empty'])}>
		    <div className={classes(styles['column'], styles['checkbox'])}/>
		    <div className={classes(styles['column'], styles['col_1'])}/>
		    <div className={classes(styles['column'], styles['col_2'])}/>
		    <div className={classes(styles['column'], styles['col_3'])}/>
		    <div className={classes(styles['column'], styles['col_4'])}/>
		    <div className={classes(styles['column'], styles['col_5'])}/>
	    </div>
    );
};

export default TableRowEmpty;
